import { initializeApp } from 'firebase/app';
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCH1x_5WgJKeE_offKpKxpTY4kuFRpFkD8',
  authDomain: 'cloudberry-843de.firebaseapp.com',
  projectId: 'cloudberry-843de',
  storageBucket: 'cloudberry-843de.firebasestorage.app',
  messagingSenderId: '429191915769',
  appId: '1:429191915769:web:c25496e7fb43cf390e5a28',
  measurementId: 'G-HPYVE1GRJF'
};

export const apiKey = firebaseConfig.apiKey;
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
